// Capture/sample:
{{#each interface.masterPorts}}
{{#if (or (not ../isPipelined) (eq channel ../channel))}}
//   {{#with (lookup ../sequenceItem.instanceVariablesByRelatedPort identifier )}}{{ ../../sequenceItemHandle.identifier }}.{{ identifier }} = {{/with}}{{ identifier }};
{{/if}}
{{/each}}
